import { jsx as _jsx } from "react/jsx-runtime";
import './Q_SortableList.scss';
import { _className, ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { QScrollWrapper } from '../QScrollWrapper.js';
import { TS_ListOrganizer } from '@nu-art/thunderstorm-frontend/components/TS_ListOrganizer/index';
export class Q_SortableList extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.items = nextProps.items;
        state.disabled = nextProps.disabled;
        return state;
    }
    renderItem = (props) => {
        const className = _className('q-sortable-list__draggable-item', props.dragged && 'dragged', this.state.disabled && 'disabled');
        const itemContent = this.props.itemRenderer(props.item, props.index);
        if (!itemContent)
            return;
        return _jsx(LL_V_L, { className: className, draggable: !this.state.disabled, onDragStart: e => {
                if (this.state.disabled)
                    return;
                const container = e.currentTarget;
                e.dataTransfer.effectAllowed = 'move';
                e.dataTransfer.setData('text/html', container);
                e.dataTransfer.setDragImage(container, 150, 30);
                props.onDragStart(e, props.index);
            }, onDragEnd: props.onDragEnd, onDragOver: e => props.onDragOver(e, props.index), onDragLeave: e => props.onDragLeave(e, props.index), children: itemContent }, props.index);
    };
    render() {
        const className = _className('q-scrollable-list', this.props.className);
        return _jsx(QScrollWrapper, { className: className, children: _jsx(TS_ListOrganizer, { items: this.state.items, renderer: this.renderItem, onOrderChanged: (order) => {
                    this.props.onChange(order);
                } }) });
    }
}
//# sourceMappingURL=Q_SortableList.js.map